import { addOptionalCursorPaginationQuery } from 'notable-common';
import { z } from 'zod';
import { FeedConnectionMethodSchema, FeedKindSchema } from './kind.js';
import { FeedListJobKindSchema } from './listJob.js';
const FeedQueryBooleanSchema = z.stringbool({ truthy: ['true'], falsy: ['false'] });
/** Every filter the feed list offers, each narrowing the list rather than selecting one feed. */
export const FeedFindAllQuerySchema = z
    .object({
    q: z.string().min(1).optional(),
    kind: FeedKindSchema.optional(),
    enabled: FeedQueryBooleanSchema.optional(),
    ingestEnabled: FeedQueryBooleanSchema.optional(),
    itemTrackingEnabled: FeedQueryBooleanSchema.optional(),
    practiceId: z.uuid().optional(),
    listJobKind: FeedListJobKindSchema.nullish(),
    includeDeleted: FeedQueryBooleanSchema.optional(),
    appendWhenAutomated: FeedQueryBooleanSchema.optional(),
    removeWhenAutomated: FeedQueryBooleanSchema.optional(),
    organizationId: z.uuid().optional(),
    jobKinds: z.array(FeedListJobKindSchema).optional(),
    connectionMethod: FeedConnectionMethodSchema.optional(),
})
    .strict();
/** The same filters, plus the cursor page the staff list pages through. */
export const FeedFindAllPaginatedQuerySchema = addOptionalCursorPaginationQuery(FeedFindAllQuerySchema);
//# sourceMappingURL=findAll.js.map